// 单词积分计算
export function calculateWordScore(word, usedLetters) {
  const baseScore = Array.from(word.toUpperCase()).reduce((sum, letter) => {
    return sum + (letterScores[letter] || 0);
  }, 0);
  
  // 长度倍率
  const lengthMultiplier = getLengthMultiplier(word.length);
  
  // 特殊奖励
  const bonus = calculateBonus(word, usedLetters);
  
  return Math.round(baseScore * lengthMultiplier + bonus);
}

// 长度倍率
export function getLengthMultiplier(length) {
  // 调整为 2 字母起；降低短词收益，鼓励长词
  const multipliers = {
    2: 1.0,
    3: 1.2,
    4: 1.5,
    5: 2.0,
    6: 2.5,
    7: 3.0
  };
  return multipliers[length] || 3.2;
}

// 特殊奖励计算
export function calculateBonus(word, usedLetters) {
  let bonus = 0;
  
  // 使用稀有字母奖励
  const rareLetters = ['Z', 'Q', 'X', 'J', 'K'];
  const rareCount = Array.from(word.toUpperCase()).filter(letter => 
    rareLetters.includes(letter)
  ).length;
  bonus += rareCount * 5;
  
  // 使用全部手牌奖励
  if (usedLetters && usedLetters.length >= 7) {
    bonus += 20;
  }
  
  // 单词难度奖励（基于词频）
  const difficultyBonus = calculateDifficultyBonus(word);
  bonus += difficultyBonus;
  
  return bonus;
}

// 单词难度奖励（简单实现）
export function calculateDifficultyBonus(word) {
  const length = word.length;
  if (length >= 8) return 15;
  if (length >= 6) return 10;
  if (length >= 4) return 5;
  return 0;
}

// 字母分值（从letterDistribution导入，这里重新定义以确保独立）
const letterScores = {
  'A': 1, 'B': 3, 'C': 3, 'D': 2, 'E': 1,
  'F': 4, 'G': 2, 'H': 4, 'I': 1, 'J': 8,
  'K': 5, 'L': 1, 'M': 3, 'N': 1, 'O': 1,
  'P': 3, 'Q': 10, 'R': 1, 'S': 1, 'T': 1,
  'U': 1, 'V': 4, 'W': 4, 'X': 8, 'Y': 4, 'Z': 10
};

// 验证单词格式
export function isValidWordFormat(word) {
  if (!word || typeof word !== 'string') return false;
  // Allow 2-letter words (previously 3)
  if (word.length < 2) return false;
  if (!/^[A-Za-z]+$/.test(word)) return false;
  return true;
}
